import { useEffect, useState, useRef } from "react";
import api from "@/lib/api";
import { Bell } from "lucide-react";

export default function NotificationsBell() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const load = () => api.get("/notifications").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onNotif = () => load();
    document.addEventListener("mousedown", onClick);
    window.addEventListener("permitco:notif", onNotif);
    return () => { clearInterval(t); document.removeEventListener("mousedown", onClick); window.removeEventListener("permitco:notif", onNotif); };
  }, []);

  const unread = items.filter((n) => n.statut === "non_lu");
  const markRead = async (n) => { if (n.statut === "non_lu") { await api.post(`/notifications/${n.id}/lu`).catch(() => {}); load(); } };

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button className="iconbtn" data-testid="notif-bell" aria-label="Notifications" onClick={() => setOpen((o) => !o)}>
        <Bell size={16} />
        {unread.length > 0 && (
          <span data-testid="notif-count" style={{ position: "absolute", top: 0, right: 0, background: "var(--rouge, #B3382C)", color: "#fff", borderRadius: 10, fontSize: ".6rem", minWidth: 15, height: 15, lineHeight: "15px", textAlign: "center", padding: "0 3px" }}>{unread.length}</span>
        )}
      </button>
      {open && (
        <div data-testid="notif-panel" style={{ position: "absolute", right: 0, top: 34, width: 320, maxHeight: 380, overflowY: "auto", background: "var(--card, #fff)", border: "1px solid var(--ligne)", borderRadius: 10, boxShadow: "0 12px 32px rgba(0,0,0,.18)", zIndex: 50, padding: 8 }}>
          <div style={{ fontSize: ".78rem", fontWeight: 600, padding: "6px 8px", color: "var(--text-muted)" }}>Notifications</div>
          {items.length ? items.map((n) => (
            <div key={n.id} onClick={() => markRead(n)} data-testid={`notif-${n.id}`}
              style={{ padding: "8px 10px", borderRadius: 8, cursor: "pointer", background: n.statut === "non_lu" ? "var(--sarcelle-p, #EAF3F4)" : "transparent", marginBottom: 4 }}>
              <div style={{ fontSize: ".8rem" }}>{n.contenu}</div>
              <div style={{ fontSize: ".68rem", color: "var(--text-muted)" }}>{n.operationId} · {new Date(n.date).toLocaleString("fr-FR")}</div>
            </div>
          )) : <div className="empty" style={{ padding: 12 }}>Aucune notification.</div>}
        </div>
      )}
    </div>
  );
}
